import PropTypes from 'prop-types'

import {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {readEndpoint} from 'redux-json-api'

import FuneralHomeClientSummariesTable from '../../shared_components/FuneralHomeClientSummariesTable'
import routerUtils from '../../../../../lib/routerUtils'

import {
  useClientSummariesTableData,
  useFuneralHomeClientSummariesTableState
} from '../../../../../lib/hooks'

import {webAppsUrl} from '../../../../../lib/urlTools'

export const QuarterbackClientSummariesContainer = props => {
  const {
    checkboxFilterOptions,
    clientSummaries,
    fetchClientSummaries,
    isFiltering,
    loading,
    pages,
    recordCount,
    setRefetchCheckboxFilterOptions
  } = useClientSummariesTableData(props.readEndpoint)

  const [funeralHomes, setFuneralHomes] = useState([])

  useEffect(() => {
    props.readEndpoint('firm-summaries/funeral-homes').then(response => {
      const data = response.body.data.attributes['funeral-homes']
      setFuneralHomes(data)
    })
  }, [])

  const {
    filtered,
    handleFilteredChange,
    handlePageSizeChange,
    handleSortedChange,
    page,
    pageSize,
    setPage,
    sorted
  } = useFuneralHomeClientSummariesTableState(fetchClientSummaries)

  const handleAddClient = () => {
    routerUtils.push('pro/quarterback-admin/clients/add')
  }

  const handleRowClick = clientSeatId => {
    window.open(
      webAppsUrl(`pro/quarterback-admin/clients/${clientSeatId}`), '_blank'
    ).focus()
  }

  const refreshTable = () => {
    const tableState = {
      filtered,
      page,
      pageSize,
      sorted
    }

    fetchClientSummaries(tableState)
    setRefetchCheckboxFilterOptions(true)
  }

  return (
    <div className='quarterback-clients-summaries-container'>
      <FuneralHomeClientSummariesTable
        checkboxFilterOptions={checkboxFilterOptions}
        clientSummaries={clientSummaries}
        filtered={filtered}
        isFiltering={isFiltering}
        isQuarterback={true}
        loading={loading}
        onAddClient={handleAddClient}
        onFetchData={fetchClientSummaries}
        onFilteredChange={newFilters => handleFilteredChange(newFilters)}
        onPageChange={newPage => setPage(newPage)}
        onPageSizeChange={newPageSize => handlePageSizeChange(newPageSize)}
        onRowClick={handleRowClick}
        onSortedChange={newSorted => handleSortedChange(newSorted)}
        page={page}
        pageSize={pageSize}
        pages={pages}
        recordCount={recordCount}
        sorted={sorted}
      />
      {
        routerUtils.childrenWithProps(
          props.children, {
            readEndpoint: props.readEndpoint,
            funeralHomes,
            onClientAdded: refreshTable
          }
        )
      }
    </div>
  )
}

QuarterbackClientSummariesContainer.propTypes = {
  readEndpoint: PropTypes.func.isRequired
}

export default connect(null, {readEndpoint})(QuarterbackClientSummariesContainer)
